import { en } from './en';
import { nl } from './nl';

const SUPPORTED = { en, nl };
const DEFAULT = 'en';

function getLanguage() {
    const lang = localStorage.getItem('dealerLanguage');
    return SUPPORTED[lang] ? lang : DEFAULT;
}

export function t(path) {
    const lang = getLanguage();
    const strings = SUPPORTED[lang] || en;
    
    const keys = path.split('.');
    let result = strings;
    for (const key of keys) {
        result = result?.[key];
        if (result === undefined) {
            console.warn(`[i18n] Missing key: "${path}" for lang: "${lang}"`);
            return path;
        }
    }
    return result;
}

export function getActiveLanguage() {
    return getLanguage();
}